import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

interface BackButtonConfig {
  shouldShow: boolean;
  handleBack: () => void;
}

export function useSmartBackButton(): BackButtonConfig {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = useCallback(() => {
    const currentPath = location.pathname;

    // Special handling for eleccion flow - check if there are EleccionNavigation components
    // that should handle the back navigation instead
    if (currentPath.startsWith('/eleccion/')) {
      // For eleccion routes, let the component-level navigation handle it
      // by dispatching a custom event that components can listen to
      const backEvent = new CustomEvent('headerBackClick', { 
        detail: { path: currentPath } 
      });
      window.dispatchEvent(backEvent);
      return;
    }

    // Define the navigation hierarchy for main pages
    const navigationMap: Record<string, string> = {
      '/introduccion': '/',
      '/eleccion': '/introduccion',
    };

    // Check if we have a specific mapping for this route
    if (navigationMap[currentPath]) {
      navigate(navigationMap[currentPath]);
    } else {
      // For any other routes, use browser back as fallback
      navigate(-1);
    }
  }, [navigate, location.pathname]);

  // Determine if back button should be shown
  const shouldShow = location.pathname !== '/';

  return {
    shouldShow,
    handleBack,
  };
}